import { useTranslation } from 'react-i18next';
import { P, SvgIcon } from '@salecycle/ui-component-library';
import { ConfigurationOption } from '../../components/ConfigurationOption';
import styled from 'styled-components';

const OverrideWarningContainer = styled.div`
  display: flex;
  align-items: center;
`;

const OverrideWarningIcon = styled(SvgIcon)`
  margin-bottom: ${({ theme }) => theme.designToken.spacing2};
`;

const OverrideWarningText = styled(P)`
  font-size: 12px;
  color: #666;
  font-style: italic;
`;

export function PageLoadConfiguration() {
  const { t } = useTranslation('campaigns');

  return (
    <ConfigurationOption>
      <OverrideWarningContainer>
        <OverrideWarningIcon name="triangle-exclamation" size="16" />
        <OverrideWarningText>{t('onsite.triggerOverrideNote')}</OverrideWarningText>
      </OverrideWarningContainer>
    </ConfigurationOption>
  );
}
